import { I18n } from "i18n-js";

let i18nInstance: I18n | null = null;

export function configureI18n(translations: Record<string, unknown>, locale = "en"): void {
  i18nInstance = new I18n(translations);
  i18nInstance.defaultLocale = "en";
  i18nInstance.locale = locale;
  i18nInstance.enableFallback = true;
}

export function switchLocale(locale: string, translations: Record<string, unknown>): void {
  if (!i18nInstance) {
    throw new Error("i18n not configured. Call configureI18n() before using switchLocale().");
  }
  i18nInstance.store(translations);
  i18nInstance.locale = locale;
}

export function getLocale(): string {
  if (!i18nInstance) {
    return "en";
  }
  return i18nInstance.locale;
}

export function t(key: string, options?: Record<string, unknown>): string {
  if (!i18nInstance) {
    throw new Error("i18n not configured. Call configureI18n() before using t().");
  }
  return i18nInstance.t(key, options);
}

export function tList(key: string, options?: Record<string, unknown>): string[] {
  if (!i18nInstance) {
    throw new Error("i18n not configured. Call configureI18n() before using tList().");
  }
  const result = i18nInstance.t(key, options);
  if (!Array.isArray(result) || !result.every((item) => typeof item === "string")) {
    throw new Error(`Expected string array translation for key "${key}", got ${typeof result}`);
  }
  return result;
}
